import { getQuickshareDetails } from '../ai-assist/queries/useGetQuickShareDetails';
import { IQuickShareMarkAsSentParams } from '../ai-assist/queries/useShortUrlMutation';
import { errorToast } from '../toasts/error';

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);
const copyToClipboardQuickShare = async (url: string, html?: string) => {
  const listener = (e: ClipboardEvent) => {
    if (e.clipboardData) {
      e.clipboardData.setData('text/html', html || '');
      e.clipboardData.setData('text/plain', url);
    }
    e.preventDefault();
  };

  document.addEventListener('copy', (e) => listener(e), {
    once: true,
  });
  document.execCommand('copy');
};

const copyToClipboardQuickShareSafari = async (
  payload: IQuickShareMarkAsSentParams
) => {
  const quickshareDetails = async () => {
    const { videoId, videoId: _, ...rest } = payload;
    const getQuickshareData = await getQuickshareDetails(videoId, {
      ...rest,
    });
    return {
      url: getQuickshareData.data.url,
      html: rest.generatedText || getQuickshareData.data.html,
    };
  };

  const textArea = document.createElement('textArea') as HTMLTextAreaElement;

  await navigator.clipboard
    // @ts-ignore
    .write([
      // @ts-ignore
      await new ClipboardItem({
        'text/plain': new Promise(async (resolve) => {
          resolve(
            new Blob([(await quickshareDetails()).url], {
              type: 'text/plain',
            })
          );
        }),

        'text/html': new Promise(async (resolve) => {
          textArea.style.visibility = 'hidden';
          textArea.setAttribute('contenteditable', 'true');
          textArea.value = (await quickshareDetails()).html;
          document.body.appendChild(textArea);
          const range = document.createRange();
          range.selectNodeContents(textArea);
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
          textArea?.setSelectionRange(0, 999999);
          resolve(
            new Blob([textArea.value], {
              type: 'text/html',
            })
          );
        }),
      }),
    ]);

  if (textArea && textArea.remove) {
    textArea.remove();
  }
};

export const copyClipboard = async (
  url: string,
  html: string,
  params: IQuickShareMarkAsSentParams
) => {
  try {
    if (isSafari) {
      await copyToClipboardQuickShareSafari(params);
    } else {
      await copyToClipboardQuickShare(url, html);
    }
  } catch (error) {
    errorToast({
      title: 'Failed to copy to clipboard',
    });
  }
};
